import {getJSON} from '@/config/config.js'
import {YXHJ,urlpostfix,jsonpostfix} from '@/config/global.js'

/*查询数据接口*/

export function getyxhjJsondata(){
  return getJSON(`${jsonpostfix}allWzJSON/${YXHJ}/${YXHJ}.json`,);
}



// WEBPACK FOOTER //
// ./src/api/herohome.js